import React from 'react';

function ServicesIndustrialSection() {
  const styles = {
    section: {
      width: '100%',
      maxWidth: 1920,
      margin: '0 auto',
      padding: '80px clamp(24px, 12.5vw, 240px)',
      boxSizing: 'border-box',
      background: '#FFFFFF'
    },
    inner: {
      display: 'flex',
      alignItems: 'stretch',
      justifyContent: 'space-between',
      gap: 48,
      flexWrap: 'wrap'
    },
    leftCol: {
      flex: '1 1 380px',
      maxWidth: 520,
      minWidth: 280,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      minHeight: 0
    },
    rightCol: {
      flex: '1 1 50%',
      maxWidth: 640,
      minWidth: 280,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start'
    },
    imageWrap: {
      position: 'relative',
      flex: 1,
      minHeight: 400,
      overflow: 'hidden',
      opacity: 1
    },
    sectionImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      objectPosition: 'top center',
      display: 'block'
    },
    ctaBtn: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      display: 'inline-block',
      fontFamily: 'Lato',
      fontWeight: 600,
      fontSize: 14,
      padding: '14px 28px',
      background: '#E73123',
      color: '#FFFFFF',
      textDecoration: 'none',
      textTransform: 'uppercase',
      textAlign: 'center'
    },
    overlineRow: {
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      marginBottom: 16
    },
    overline: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontStyle: 'normal',
      fontSize: 14,
      lineHeight: '100%',
      letterSpacing: '-0.01em',
      textTransform: 'uppercase',
      color: '#090909',
      margin: 0
    },
    overlineRule: {
      width: 80,
      height: 2,
      background: '#E73123',
      flexShrink: 0
    },
    titleRow: {
      marginBottom: 24
    },
    titleRed: {
      fontFamily: 'Lato',
      fontWeight: 800,
      fontStyle: 'normal',
      fontSize: 32,
      lineHeight: 1.2,
      letterSpacing: 0,
      textTransform: 'uppercase',
      color: '#E73123',
      margin: 0
    },
    titleBlack: {
      fontFamily: 'Lato',
      fontWeight: 800,
      fontStyle: 'normal',
      fontSize: 32,
      lineHeight: 1.2,
      letterSpacing: 0,
      textTransform: 'uppercase',
      color: '#090909',
      margin: 0
    },
    body: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontStyle: 'normal',
      fontSize: 16,
      lineHeight: 1.7,
      letterSpacing: 0,
      color: '#838383',
      margin: '0 0 24px 0'
    },
    solutionsHeading: {
      fontFamily: 'Lato',
      fontWeight: 700,
      fontStyle: 'normal',
      fontSize: 20,
      lineHeight: 1.4,
      letterSpacing: 0,
      color: '#E73123',
      margin: '0 0 16px 0'
    },
    solutionsGrid: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '8px 32px',
      marginBottom: 24
    },
    solutionItem: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontStyle: 'normal',
      fontSize: 16,
      lineHeight: 1.7,
      letterSpacing: 0,
      textTransform: 'capitalize',
      color: '#090909',
      margin: 0,
      paddingLeft: 20,
      position: 'relative'
    },
    bullet: {
      position: 'absolute',
      left: 0,
      top: 14,
      width: 6,
      height: 6,
      borderRadius: '50%',
      background: '#E73123'
    }
  };

  const solutions = [
    'Power plants and energy facilities',
    'Processing units and heavy industrial complexes',
    'Warehouses and logistics hubs',
    'Manufacturing plants'
  ];

  return React.createElement('section', { style: styles.section, className: 'section-padding' },
    React.createElement('div', { style: styles.inner, className: 'section-inner-wrap' },
      React.createElement('div', { style: styles.leftCol, className: 'section-image-col' },
        React.createElement('div', { style: styles.imageWrap, className: 'section-image-wrap' },
          React.createElement('img', {
            src: '/industrialstrength.jpg',
            alt: 'Industrial and manufacturing construction',
            style: styles.sectionImage
          }),
          React.createElement('a', { href: '#contact', style: styles.ctaBtn }, 'REQUEST A CONSULTATION')
        )
      ),
      React.createElement('div', { style: styles.rightCol, className: 'section-text-col' },
        React.createElement('div', { style: styles.overlineRow },
          React.createElement('p', { style: styles.overline }, 'INDUSTRIAL STRENGTH'),
          React.createElement('div', { style: styles.overlineRule })
        ),
        React.createElement('div', { style: styles.titleRow },
          React.createElement('span', { style: styles.titleRed }, 'INDUSTRIAL &'),
          React.createElement('br'),
          React.createElement('span', { style: styles.titleBlack }, 'MANUFACTURING'),
          React.createElement('br'),
          React.createElement('span', { style: styles.titleBlack }, 'FACILITIES')
        ),
        React.createElement('p', { style: styles.body },
          'Industrial structures demand robust foundations capable of withstanding heavy machinery loads, vibrations, and dynamic operational forces.'
        ),
        React.createElement('h3', { style: styles.solutionsHeading }, 'We Provide Foundation Solutions For:'),
        React.createElement('div', { style: styles.solutionsGrid },
          solutions.map(function (item, i) {
            return React.createElement('p', { key: i, style: styles.solutionItem },
              React.createElement('span', { style: styles.bullet }),
              item
            );
          })
        ),
        React.createElement('p', { style: styles.body },
          'Our engineering team conducts detailed site analysis and load calculations to design foundations that ensure structural stability and operational efficiency. We focus on minimizing downtime, optimizing execution schedules, and maintaining strict safety compliance throughout the project lifecycle.'
        )
      )
    )
  );
}

export default ServicesIndustrialSection;
